module.exports = __webpack_public_path__ + "static/media/icono-obrir.a717d26b.png";